import { Typography } from "@mui/material";

export default function EUComplianceText() {
  return (
    <Typography sx={{ fontSize: "12px", fontWeight: "400", textAlign: "center", mt: "0.5rem", color: "#bebebe" }}>
      Deepsense uses an LLM to answer questions and can make mistakes. Please check its answers.
    </Typography>
  );
}
